import moment from 'moment';

export function setDefaultFilterSearchDashboardFac(filterSearch: any, numberMonthsBehind?: number): any {
  let startdate: any = moment();
  startdate = startdate.subtract(numberMonthsBehind, 'months');
  const to = moment(new Date()).format('YYYY-MM-DD[T]23:59:59.999[Z]');
  const from = moment(new Date(startdate)).format('YYYY-MM-DD[T]00:00:00.000[Z]');

  if (!numberMonthsBehind) {
    numberMonthsBehind = 12;
  }

  if (!filterSearch.and.ranges) {
    filterSearch.and.ranges = [];
  }

  if (filterSearch.and.ranges.find(r => r.field?.match('creation_date'))) {
    return filterSearch;
  }
  
  filterSearch.and.ranges.push({
    field: "creation_date",
    from,
    to
  });
  
  return filterSearch;
}